import '@fortawesome/fontawesome-free/css/all.min.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    icons: {
      iconfont: 'fa'
    },
    options: {
      customProperties: true,
    },
    dark: true,
    themes: {
      dark: {
        primary: '#F37333',
        backgroundColor: '#0b0d19',
        background: '#0b0d19',
        error: '#c8498c'
      },
    },
  }
});
